var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-block grey lighten-4 grey--text text--darken-2 rounded font-weight-bold px-2"},[_c('small',[_vm._v("SKU "+_vm._s(_vm.sku))])])}
var staticRenderFns = []

export { render, staticRenderFns }